//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('gisPositionAdd', {
//        templateUrl: 'views/components/views/gisPositionAdd/gisPositionAdd.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'gisPositionAddService', function ($stateParams, stateService, translateService, modalService, gisPositionAddService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;
//            let lat = $stateParams.lat;
//            let lng = $stateParams.lng;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                readyGisPositionNote: true,
//                edit: {},
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadEdit() {
//                vm.model.edit = (await gisPositionAddService.getEdit({
//                    argtype: argType,
//                    argvalue: argValue,
//                    lat: lat,
//                    lng: lng
//                }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                gisPositionAddService.saveObj(vm.model.edit).then((response) => {
//                    if (response[0] && response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: (dialogItself) => {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
